import React, { Component } from "react";
class CardHeader extends Component {
  static defaultProps = {
    HeaderText: 'HeaderText',
    ButtonText: 'ButtonText',
    Button: undefined, //This is a function
    bodyactive: true,
    disabled: false,
    headerClassName: '',
    sectionNumber: undefined,
    subtotal: undefined,
    subtotalRev: undefined,
    subtotalHi: false,
  };

  render() {
    return (
      <header className={'card__header' + (this.props.disabled ? ' disabledcard' : '')}>
        <h1
          className={'font' + (this.props.headerClassName ? ' ' + this.props.headerClassName : '')}
          onClick={() => this.props.changeBodyStatus()}
        >
          {this.props.sectionNumber !== undefined && <span className='pd-num'>{this.props.sectionNumber}</span>}
          <span className='pd-title-text'>{this.props.HeaderText}</span>
          <span className='pd-sp' />
          {this.props.subtotal !== undefined && (
            <span className='pd-subtotal'>
              <span className='amt'>{this.props.subtotal}</span>
              {this.props.subtotalRev !== undefined && (
                <span className={'rev' + (this.props.subtotalHi ? ' hi' : '')}>{this.props.subtotalRev}</span>
              )}
            </span>
          )}
          <i className={`pd-chev fa-solid fa-chevron-${this.props.bodyactive ? 'up' : 'down'}`} />
        </h1>
        {this.props.Button === undefined ? null : (
          <div className='card__bodyHeaderbutton'>
            <div
              className='figmabuttondestroy destroy smallnormal'
              onClick={() => this.props.Button()}
            >
              {this.props.ButtonText}
            </div>
          </div>
        )}
      </header>
    );
  }
}

export default CardHeader;
